import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const StatusCheck = () => {
  const [serialNumber, setSerialNumber] = useState('');
  const [application, setApplication] = useState(null);
  const [error, setError] = useState('');

  const handleSearch = (e) => {
    e.preventDefault();
    setError('');
    setApplication(null);

    if (!serialNumber) {
      setError('Please enter a serial number.');
      return;
    }

    const localApplications = JSON.parse(localStorage.getItem('applications')) || [];
    const foundApplication = localApplications.find(app => app.serialNumber === serialNumber);

    if (foundApplication) {
      setApplication(foundApplication);
    } else {
      setError('No application found with this serial number. Please check the number and try again.');
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-center mb-6 text-gray-800">Check Application Status</h1>
      <form onSubmit={handleSearch} className="flex flex-col sm:flex-row gap-4">
        <input 
          type="text"
          value={serialNumber}
          onChange={(e) => setSerialNumber(e.target.value)}
          placeholder="Enter your serial number here..."
          className="flex-grow p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button type="submit" className="bg-blue-600 text-white font-bold py-3 px-6 rounded-md hover:bg-blue-700 transition-colors">
          Check Status
        </button>
      </form>

      {error && <p className="mt-4 text-center text-red-600 font-semibold">{error}</p>}

      {application && (
        <div className="mt-8 p-6 border rounded-lg bg-gray-50">
          <h2 className="text-xl font-bold mb-4">Application Details</h2>
          <div className="space-y-2">
            <p><strong>Serial Number:</strong> {application.serialNumber}</p>
            <p><strong>Applicant Name:</strong> {application.name_en}</p>
            <p><strong>Submission Date:</strong> {new Date(application.submissionDate).toLocaleDateString()}</p>
            <div className="flex items-center">
              <p className="mr-2"><strong>Status:</strong></p>
              <span className={`px-3 py-1 font-semibold leading-tight rounded-full text-sm ${
                application.status === 'pending' ? 'bg-yellow-200 text-yellow-900' :
                application.status === 'approved' ? 'bg-green-200 text-green-900' : 'bg-red-200 text-red-900'
              }`}>
                {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
              </span>
            </div>
          </div>

          {/* Download button for approved applications */}
          {application.status === 'approved' && (
            <div className="mt-6 text-center">
                <Link 
                    to={`/certificate/${application.serialNumber}`} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-block bg-green-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-green-700 transition-colors text-lg"
                >
                    Download / Print Certificate
                </Link>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StatusCheck;
